// extracted by mini-css-extract-plugin
export default {"chapterIconStyle":"courseChapterIconStyles_chapterIconStyle__lfI7S"};